<ion-icon name="close" class="fab-close-icon"></ion-icon><span class="button-inner"><ng-content></ng-content></span><div class="button-effect"></div>